import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function fetchBlobUrl(storagePath) {
  const t = localStorage.getItem("token");
  const res = await axios.get(`${API}/files/${storagePath}`, {
    headers: { Authorization: `Bearer ${t}` },
    responseType: "blob",
  });
  return URL.createObjectURL(res.data);
}

export function artifactUrl(runId, name) {
  const t = localStorage.getItem("token");
  return `${API}/runs/${runId}/artifact/${name}?auth=${t}`;
}

export function fileDownloadUrl(storagePath) {
  const t = localStorage.getItem("token");
  return `${API}/files/${storagePath}?auth=${t}`;
}

export default api;
